import { DocumentTypeMapping } from "../models/advanced-filter.interface";

export const StorageKeys = {
  LOGIN_METHOD: 'loginMethod',
  MENU_ITEMS: 'menuItems',
  USER_PROFILE: 'userProfile',
  USER_PERMISSIONS: 'userPermissions',
} as const;

export const LOCALES = {
  EN_IN: {value: 'en-IN'},
  EN_US: {value: 'en-US'},
}


export const CycleType = {
  IMPORT: {value: "Import", key: "IMPORT"},
  EXPORT: {value: "Export", key: "EXPORT"},
  EMPTY: {value: "Empty", key: "EMPTY"},
  BOND: {value: "Bond", key: "BOND"}
} as const;
export type Cycle = typeof CycleType[keyof typeof CycleType];

export const PaymentMode = {
  NEFT: {value: "NEFT", key: "NEFT"},
  RTGS: {value: "RTGS", key: "RTGS"},
  CASH: {value: "CASH", key: "CASH"},
  PDA: {value: "PDA", key: "PDA"}
} as const;
export type PaymentMode = typeof PaymentMode[keyof typeof PaymentMode];


export const BooleanType = {
  TRUE: {value: "Yes", key: true},
  FALSE: {value: "No", key: false},
} as const;
export type BooleanType = typeof BooleanType[keyof typeof BooleanType];

export const AttributeType = {
  STRING: {value: "String", key: "STRING"},
  BOOLEAN: {value: "Boolean", key: "BOOLEAN"},
  BIGDECIMAL: {value: "Number", key: "BIGDECIMAL"},
} as const;
export type AttributeType = typeof AttributeType[keyof typeof AttributeType];

export const InventoryType = {
  CONTAINER: {value: "Container", key: "CONTAINER"},
  TRAILER: {value: "Trailer", key: "TRAILER"},
  TRUCK: {value: "Truck", key: "TRUCK"},
  CARGO: {value: "Cargo", key: "CARGO"},
} as const;
export type InventoryType = typeof InventoryType[keyof typeof InventoryType];

export const ExaminationType = {
  SEAL_CUT_AND_EXAMINATION: {value: "Seal Cut and Examination", key: "SEAL_CUT_AND_EXAMINATION"},
  RMS_AND_EXAMINATION: {value: "RMS and Examination", key: "RMS_AND_EXAMINATION"},
  RMS: {value: "RMS", key: "RMS"},
} as const;
export type ExaminationType = typeof ExaminationType[keyof typeof ExaminationType];

export  const  ServiceTypes = {
    SPECIAL_SERVICE:{ name: 'Special Service', value: 'SPECIAL_SERVICE'  },
    GENERAL_SERVICE:{ name: 'General Service', value: 'GENERAL_SERVICE'  },   
}as const;
export type ServiceTypes = typeof ServiceTypes[keyof typeof ServiceTypes];



export  const  LocationTypes = {
    PORT:{ name: 'Port', value: 'PORT'  },
    INLAND_CONTAINER_DEPOT:{ name: 'Inland Container Depot', value: 'INLAND_CONTAINER_DEPOT'  },
    CFS:{ name:  "CFS", "value": "CFS" },
    EMPTY_DEPOT:{name:  "Empty Depot",value:  "EMPTY_DEPOT"},
    BERTHING_POINT:{name:  "Berthing Point",value:  "BERTHING_POINT"},
    PORT_TERMINAL:{name:  "Berthing Point",value:  "BERTHING_POINT"},   
    REPAIRING_YARD:{name:  "Repairing Yard",value:  "REPAIRING_YARD"}, 
   
}as const;
export type LocationTypes = typeof LocationTypes[keyof typeof LocationTypes];


export  const  CustomerTypes = {
    SHIPPING_LINE:{ name: 'Shipping Line', value: 'SHIPPING_LINE'  },
    FRIEGHT_FORWARDER:{ name: "Freight Forwarder" , value: "FRIEGHT_FORWARDER"  },
    CHA:{ name: "CHA", "value": "CHA" },
    IMPORTER:{name:  "Importer",value:  "IMPORTER"},
    EXPORTER:{name:   "Exporter",value:  "EXPORTER"},   
}as const;
export type CustomerTypes = typeof CustomerTypes[keyof typeof CustomerTypes];


export  const  JobOrderStatusTypes = {
    COMPLETED:{ name: 'Completed', value: 'COMPLETED'  },
    CANCELLED:{ name: "Cancelled" , value: "CANCELLED"  },
    EXPIRED:{ name: "Expired", value: "EXPIRED" },
    PENDING:{name:  "Pending",value:  "PENDING"}
}as const;
export type JobOrderStatusTypes = typeof JobOrderStatusTypes[keyof typeof JobOrderStatusTypes];

export enum PageAction {
  INSERT = "INSERT",
  UPDATE = "UPDATE",
  VIEW = "VIEW"
}

// Const Variables
export const PAN_NUMBER_REGEX = "^[A-Z]{5}[0-9]{4}[A-Z]{1}$";